export default "__VITE_ASSET__BQtXjKKq__";